import { usePlatformBroadcast } from "@/contexts/PlatformBroadcastContext";
import { useTermsGate } from "@/components/legal/TermsGateProvider";
import { getTourStage } from "@/components/onboarding/TourProvider";
import { BLOCKING_OVERLAY_SELECTOR, useDomPresence } from "./useDomPresence";

/**
 * Quem tem a vez antes das novidades (SPOT-07): comunicado de plataforma, portão de termos,
 * o tour obrigatório de boas-vindas (etapa ativa no armazenamento da conta) e qualquer overlay
 * que se declare com `data-blocking-overlay`. Vale para o cartão e para o ponteiro.
 *
 * Com `enabled` falso (nada para mostrar) não observa o DOM.
 *
 * @param {{ tourClientId?: string|null, enabled?: boolean }} params
 * @returns {boolean} `true` enquanto as novidades devem esperar
 */
export function useSpotlightGate({ tourClientId = null, enabled = true } = {}) {
  const { current: broadcast } = usePlatformBroadcast();
  const { blocked: termsPending } = useTermsGate();
  const overlayOpen = useDomPresence(BLOCKING_OVERLAY_SELECTOR, enabled);

  // A etapa do tour mora no armazenamento e muda em outras telas; é relida quando o layout
  // renderiza (cada troca de rota), o que basta: o tour termina navegando.
  const tourActive = tourClientId ? getTourStage(tourClientId) !== null : false;

  return Boolean(broadcast) || termsPending || overlayOpen || tourActive;
}
